import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/hu';

const DatePickerUI = (props) => {
  const { variant, clearable } = props;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="hu">
      <DatePicker
        slotProps={{
          textField: {
            variant: variant ?? 'standard',
            helperText: props.helperText,
          },
          popper: {
            style: {
              zIndex: 9999,
            },
          },
          field: { clearable: clearable ?? true, onClear: () => {} },
        }}
        sx={{ width: '100%' }}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default DatePickerUI;
